import type { PharmaVariantMetadata } from '@lib/types/pharma';

type Props = {
  metadata?: PharmaVariantMetadata | null;
  fallbackTitle?: string;
};

export default function PharmaVariantLabel({ metadata, fallbackTitle }: Props) {
  if (!metadata) {
    return fallbackTitle ? (
      <span className="text-sm text-ui-fg-subtle" translate="no">
        {fallbackTitle}
      </span>
    ) : null;
  }

  const parts: string[] = [];

  if (metadata.strength_raw) {
    parts.push(metadata.strength_raw);
  }

  if (metadata.form_raw) {
    parts.push(metadata.form_raw);
  }

  const packPart =
    metadata.pack_size != null
      ? `${metadata.pack_size}${metadata.pack_size_unit ? ` ${metadata.pack_size_unit}` : ' pack'}`
      : null;

  if (parts.length === 0 && !packPart && fallbackTitle !== 'Default') {
    return fallbackTitle ? (
      <span className="text-sm text-ui-fg-subtle" translate="no">
        {fallbackTitle}
      </span>
    ) : null;
  }

  return (
    <span className="text-sm text-ui-fg-subtle" translate="no">
      {parts.join(' ')}
      {parts.length > 0 && packPart && ' — '}
      {packPart}
    </span>
  );
}
